import { render, staticRenderFns } from "./sort-box.vue?vue&type=template&id=ecfa08b2&scoped=true&"
import script from "./sort-box.vue?vue&type=script&lang=js&"
export * from "./sort-box.vue?vue&type=script&lang=js&"
import style0 from "./sort-box.vue?vue&type=style&index=0&id=ecfa08b2&prod&lang=less&"
import style1 from "./sort-box.vue?vue&type=style&index=1&id=ecfa08b2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecfa08b2",
  null
  
)

export default component.exports